import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { appsStore, type AppsStoreState } from './AppsStore.ts';
import { selectData, selectById } from '../selectors.ts';

import { useAttach } from '../useAttach';

export function useAppsData() {
  useAttach(appsStore, 'useAppsData');
  return useStoreWithEqualityFn(appsStore.store, selectData, shallow);
}
useAppsData.store = appsStore;

export function useAppsById() {
  useAttach(appsStore, 'useAppsById');
  return useStoreWithEqualityFn(appsStore.store, selectById, shallow);
}
useAppsById.store = appsStore;

export function useApp({ appId }: { appId: string }) {
  useAttach(appsStore, 'useApp');

  const select = useCallback(
    (state: AppsStoreState) => {
      return {
        app: state.byId?.[appId] ?? null,
        appInstance: state.data?.[appId] ?? null,
        error: state.error,
        isLoading: state.isLoading,
      };
    },
    [appId]
  );

  return useStoreWithEqualityFn(appsStore.store, select, shallow);
}
useApp.store = appsStore;

export function useAppsAttach() {
  useAttach(appsStore, 'useAppsAttach');
}
useAppsAttach.store = appsStore;
